import React from 'react';
import CustomMenuItem from '../../../../../components/Menu/CustomMenuItem';
import Divider from '@mui/material/Divider';
import VectorArchived from '../../../../../styles/svg/archive-btn-icon.svg';
import restoreArchiveIcon from '../../../../../styles/svg/restore-board.svg';
import boardHeaderuploadCSVIcon from '../../../../../styles/svg/updated_upload_csv_icon.svg';
import mergeBoardIcon from '../../../../../styles/svg/updated_merge_board_icon.svg';
import mergeFieldIcon from '../../../../../styles/svg/manageFields.svg';
import IntegrationIcon  from '../../../../../styles/svg/integration.svg';

const ArchiveMenuItems = ({
  isAdmin,
  isOwner,
  isArchive,
  onArchiveClick,
  onCSVClick,
  onMergeBoardClick,
  showDividers = true,
  onManageFieldsClick,
  onSetupBoardNotificationsClick,
}) => {
  return (
    <>
      {(isAdmin || isOwner) && (
        <>
          <CustomMenuItem
            className="archive-menu-item"
            onClick={onArchiveClick}
          >
            <img
              src={isArchive ? restoreArchiveIcon : VectorArchived}
              alt="Not Found"
              className="archive-icon"
            />
            {isArchive ? "Restore Board" : "Archive the board"}
          </CustomMenuItem>
          {showDividers && <Divider className="archive-divider" />}
        </>
      )}
      {showDividers && <Divider className="archive-divider" />}
      <CustomMenuItem className="archive-menu-item" onClick={onCSVClick}>
        <img
          src={boardHeaderuploadCSVIcon}
          alt="Not Found"
          className="archive-icon"
        />
        {"Upload CSV"}
      </CustomMenuItem>
      {(isAdmin || isOwner) && (
        <>
          {showDividers && <Divider className="archive-divider" />}
          <CustomMenuItem
            className="archive-menu-item"
            onClick={onMergeBoardClick}
          >
            <img
              src={mergeBoardIcon}
              alt="Not Found"
              className="archive-icon"
            />
            Merge Board
          </CustomMenuItem>
          {/* {showDividers && <Divider className="archive-divider" />} */}
        </>
      )}

      {(isAdmin || isOwner) && (
        <>
          {showDividers && <Divider className="archive-divider" />}
          <CustomMenuItem
            className="archive-menu-item"
            onClick={onManageFieldsClick}
          >
            <img
              src={mergeFieldIcon}
              alt="Not Found"
              className="archive-icon"
              width={24}
            />
            Manage Fields
          </CustomMenuItem>
          {/* {showDividers && <Divider className="archive-divider" />} */}
        </>
      )}

      {(isAdmin || isOwner) && (
        <>
          {showDividers && <Divider className="archive-divider" />}
          <CustomMenuItem
            className="archive-menu-item"
            onClick={onSetupBoardNotificationsClick}
          >
          <img
              src={IntegrationIcon}
              alt="Not Found"
              className="archive-icon"
              width={24}
            />
            Board Integrations
          </CustomMenuItem>
        </>
      )}
    </>
  );
};

export default ArchiveMenuItems;
